/**
 * Shared "last known ZIP" storage.
 *
 * The Hero Stack LP, the homepage Stack form and the Stack tool all deal with
 * the same value, so they read/write one key instead of surface-specific ones.
 * The legacy Hero-Stack-only key is migrated on first read.
 */
const KEY = "ha_last_zip";
const LEGACY_KEY = "ha_hero_stack_zip";

export const isValidZip = (value: string | null | undefined): value is string =>
  typeof value === "string" && /^\d{5}$/.test(value.trim());

export const getLastZip = (): string | null => {
  try {
    const current = localStorage.getItem(KEY);
    if (isValidZip(current)) return current.trim();
    const legacy = localStorage.getItem(LEGACY_KEY);
    if (isValidZip(legacy)) {
      const zip = legacy.trim();
      localStorage.setItem(KEY, zip);
      return zip;
    }
  } catch (_) {}
  return null;
};

export const setLastZip = (value: string) => {
  if (!isValidZip(value)) return;
  try {
    localStorage.setItem(KEY, value.trim());
  } catch (_) {}
};
